module.exports = __webpack_public_path__ + "static/media/download_black.ce0de097.png";